<template>
    <layout>
        <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
            <!-- ========== GET IN TOUCH 表单区域 ========== -->
            <div class="contact-form-section">
                <div class="contact-form-container">
                    <!-- 左侧：标题 + 描述 + 联系信息 -->
                    <div class="form-left">
                        <div class="form-header">
                            <div style="display: flex;align-items: center;">
                                <span style="margin-right: 8px;"> <img src="@/assets/images/icons/Icon.png" alt="address" /></span>
                            <h2 class="form-title">GET IN TOUCH</h2>
                            </div>
                             
                        </div>
                        <p class="form-subtitle">{{ $t('contact.name') }}</p>
                        <p class="form-desc">
                            {{ $t('contact.formDesc') }}
                        </p>
                        
                        <div class="info-card">
                            <div class="info-item">
                                <div class="info-icon">
                                    <img src="@/assets/images/icons/Div [flex] (1).png" alt="email" />
                                </div>
                                <div>
                                    <p class="info-label">{{ $t('contact.sendEmail') }}</p>
                                    <p class="info-value">client@matrixpower.org</p>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <img src="@/assets/images/icons/Div [flex].png" alt="address" />
                                </div>
                                <div>
                                    <p class="info-label">{{ $t('contact.companyAddress') }}</p>
                                        <p class="info-value">{{ $t('contact.HongKong_1') }}</p>
                                    <p class="info-value" style="margin-top: 6px;">{{ $t('footer.address') }}</p>
                                
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 右侧：表单 -->
                    <div class="form-right">
                        <form class="contact-form" @submit.prevent="submitForm">
                            <div class="form-group">
                                <label>{{ $t('contact.yourEmail') }}</label>
                                <input type="email" v-model="form.email" :placeholder="$t('contact.emailPlaceholder')" />
                            </div>
                            <div class="form-group">
                                <label>{{ $t('contact.yourName') }}</label>
                                <input type="text" v-model="form.name" :placeholder="$t('contact.namePlaceholder')" />
                            </div>
                            <div class="form-group">
                                <label>{{ $t('contact.yourQuestion') }}</label>
                                <textarea v-model="form.message" :placeholder="$t('contact.questionPlaceholder')" rows="5"></textarea>
                            </div>
                            <button type="submit" class="submit-btn">{{ $t('contact.submit') }}</button>
                        </form>
                    </div>
                </div>
            </div>
            <!-- ========== GET IN TOUCH 表单区域结束 ========== -->

        </div>
    </layout>
</template>

<script>
import Layout from "@/components/layouts/Layout";
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import SalScrollAnimationMixin from "@/mixins/SalScrollAnimationMixin";

export default {
    name: 'Contact',
    components: { Breadcrumb, Layout },
    mixins: [SalScrollAnimationMixin],
    data() {
        return {
            form: {
                email: '',
                name: '',
                message: ''
            }
        }
    },
    methods: {
        submitForm() {
            console.log('Form submitted:', this.form);
            alert(this.$t('contact.submitSuccess'));
            this.form = { email: '', name: '', message: '' };
        }
    }
}
</script>

<style scoped lang="scss">
// ========================================
// 设计规范
// ========================================
$bg-card: #161b26;
$bg-input: #0A0A0A;
$border-form: #86909C;
$border-input: rgba(255, 255, 255, 0.1);
$text-white: #ffffff;
$text-muted: rgba(255,255,255,0.5);
$text-label: rgba(255,255,255,0.3);
$text-get-in-touch: #D1D5DC;      // GET IN TOUCH 文字颜色
$gold: #ffd700;
$gold-hover: #e6c200;
$radius: 8px;
$transition: all 0.3s ease;

// ========================================
// 主容器
// ========================================
.contact-form-section {
    width: 100%;
    max-width: 1400px;
    margin: 80px auto 120px;
    padding: 0 20px;
}

// ========================================
// 表单容器 - 左右两栏布局
// ========================================
.contact-form-container {
    display: flex;
    gap: 60px;
    background: $bg-card;
    border-radius: 16px;
    padding: 50px 56px 50px 60px;
}

// ========================================
// 左侧：标题 + 描述 + 联系信息
// ========================================
.form-left {
    flex: 1;
    min-width: 0;

    .form-header {
        display: inline-block;
        border: 1px solid $border-form;    // 边框 #86909C
        border-radius: 20px;
        padding: 4px 16px;
        margin-bottom: 16px;
      
    }

    .form-title {
        font-size: 13px;
        color: $text-get-in-touch;         // 颜色 #D1D5DC
        font-weight: 600;
        letter-spacing: 3px;
        text-transform: uppercase;
        margin: 0;
    }

    .form-subtitle {
        font-size: 60px;
        color: $text-white;
        font-weight: 700;
        margin-bottom: 12px;
        letter-spacing: 1px;
    }

    .form-desc {
        font-size: 18px;
        color: #86909C;
        line-height: 1.8;
        margin-bottom: 32px;
        max-width: 540px;
    }

    .info-card {
        display: flex;
        flex-direction: column;
        gap: 32px;
        margin-top: 100px;
    }

    .info-item {
        display: flex;
        align-items: flex-start;
        gap: 14px;

        .info-icon {
            width: 40px;
            height: 40px;
            min-width: 40px;
            background: rgba(255, 215, 0, 0.06);
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                // width: 18px;
                // height: 18px;
                // object-fit: contain;
                // opacity: 0.5;
                // filter: brightness(0) invert(1);
            }
        }

        .info-label {
            font-size: 14px;
            color: #FFFFFF;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            margin-bottom: 2px;
        }

        .info-value {
            font-size: 12px;
            color: #86909C;
            line-height: 1.6;
            margin: 0;
        }
    }
}

// ========================================
// 右侧：表单 - 纵向排列
// ========================================
.form-right {
    flex: 0 0 562px;    // 宽 562
    min-width: 340px;
    padding-top: 10px;

    .contact-form {
        height: 608px;  // 高 608
        display: flex;
        flex-direction: column;
        padding: 24px 24px 28px;
        background: $bg-input;
        border: 1px solid $border-form;
        border-radius: $radius;

        // 第三个表单组（您的问题）撑满剩余高度
        .form-group:nth-of-type(3) {
            flex: 1;
            display: flex;
            flex-direction: column;

            textarea {
                flex: 1;
            }
        }

        .form-group {
            margin-bottom: 20px;

            label {
                display: block;
                font-size: 14px;
                color: rgba(255, 255, 255, 0.5);
                margin-bottom: 8px;
                font-weight: 400;
            }

            input,
            textarea {
                width: 100%;
                padding: 14px 18px;
                background: #111111;
                border: 1px solid $border-input;
                border-radius: $radius;
                color: $text-white;
                font-size: 14px;
                transition: border-color 0.3s ease;
                outline: none;
                box-sizing: border-box;
                font-family: inherit;

                &::placeholder {
                    color: rgba(255, 255, 255, 0.2);
                }

                &:focus {
                    border-color: $gold;
                }
            }

            textarea {
                resize: vertical;
                min-height: 120px;
                line-height: 1.6;
            }
        }

        .submit-btn {
            width: 100%;
            margin-top: 4px;
            padding: 15px 0;
            background: $gold;
            color: #0a0e17;
            border: none;
            border-radius: $radius;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: $transition;

            &:hover {
                background: $gold-hover;
                transform: translateY(-2px);
                box-shadow: 0 8px 30px rgba(255, 215, 0, 0.25);
            }

            &:active {
                transform: translateY(0);
            }
        }
    }
}

// ========================================
// 响应式设计
// ========================================

// ----- 平板 (≤1200px) -----
@media (max-width: 1200px) {
    .contact-form-container {
        gap: 40px;
        padding: 40px 32px;
    }

    .form-right {
        flex: 0 0 360px;
        min-width: 280px;
    }
}

// ----- 手机 & 小屏设备 (≤992px) -----
@media (max-width: 992px) {
    .contact-form-section {
        margin: 40px auto 80px;
        padding: 0 16px;
    }

    .contact-form-container {
        flex-direction: column;
        gap: 32px;
        padding: 32px 24px;
        border-radius: 12px;
    }

    .form-left {
        .form-desc {
            max-width: 100%;
        }

        .info-card {
            flex-direction: row;
            flex-wrap: wrap;
            gap: 24px;
        }

        .info-item {
            flex: 1;
            min-width: 180px;
        }
    }

    .form-right {
        flex: 1;
        min-width: auto;
        padding-top: 0;
        border-top: 1px solid rgba(255, 255, 255, 0.06);
        padding-top: 28px;

        .contact-form {
            height: auto;   // 移动端恢复自然高度
            padding: 20px 20px 24px;
        }
    }
}

// ----- 小手机 (≤576px) -----
@media (max-width: 576px) {
    .contact-form-section {
        margin: 20px auto 60px;
    }

    .contact-form-container {
        padding: 24px 16px;
        border-radius: 10px;
    }

    .form-left {
        .form-subtitle {
            font-size: 24px;
        }

        .form-desc {
            font-size: 13px;
        }

        .info-item {
            min-width: 100%;
            
            .info-value {
                font-size: 13px;
            }
        }
    }

    .form-right {
        .contact-form {
            padding: 16px 16px 20px;

            .form-group {
                margin-bottom: 16px;

                label {
                    font-size: 13px;
                }

                input,
                textarea {
                    padding: 12px 14px;
                    font-size: 13px;
                    background: $bg-input;
                }

                textarea {
                    min-height: 100px;
                }
            }

            .submit-btn {
                font-size: 15px;
                padding: 13px 0;
            }
        }
    }
}
</style>